import { useCallback } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';
import { useSharedStateSelector } from '@trello/shared-state';

import { boardSwitcherSharedState } from './boardSwitcherSharedState';

export const useBoardSwitcherMode = () => {
  const { value: isBoardSwitcherPanelEnabled } = useFeatureGate(
    'billplat_board_switcher_panel',
  );

  const mode = useSharedStateSelector(
    boardSwitcherSharedState,
    useCallback((state) => state.mode, []),
  );

  if (isBoardSwitcherPanelEnabled) {
    return mode;
  }

  return 'modal';
};
